export default __webpack_public_path__ + "static/media/token-arrow.e2911a6b.svg";